var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-detail-item",style:({ 'flex-direction': _vm.direction })},[_c('div',{staticClass:"group-detail-name",style:({
			width: _vm.labelWidth ? _vm.labelWidth + 'px' : undefined,
		})},[_c('p',[_vm._v(_vm._s(_vm.name + (_vm.direction === 'row' ? '：' : '')))])]),_c('div',{staticClass:"group-detail-info"},[_c('div',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }